module.exports = __webpack_public_path__ + "static/media/user.1ce78dd7.svg";